/* Luvlyn · Verzenden, retour en garantie (/pages/verzenden-en-retourneren; ontwerp:
   verzenden-en-retourneren.html en js/verzenden.js). Alleen wat deze pagina extra doet. De bezorgdatum
   ([data-bezorg]), het geluid en de chat (ook een vraag uit een link, #geld-terug) doet assets/site.js.
   De klok tot 17:00: de wijzers op de tijd van nu, en een vak van nu tot 17:00 als je op een werkdag
   vóór 17:00 kijkt (dezelfde regel als de bezorgbelofte in site.js). Om de 30 seconden bij, zolang het
   tabblad zichtbaar is; geen scroll-listeners. */
(() => {
  const klokken = [...document.querySelectorAll('[data-vz-klok]')];
  if (!klokken.length) return;

  function klok(){
    const nu = new Date();
    const minuten = nu.getHours() * 60 + nu.getMinutes();
    const werkdag = nu.getDay() >= 1 && nu.getDay() <= 5;
    const uur = ((nu.getHours() % 12) + nu.getMinutes() / 60) * 30;     // 12 uur is een hele ronde
    const min = nu.getMinutes() * 6;
    const rest = 17 * 60 - minuten;                                     // minuten tot 17:00
    const vak = werkdag && rest > 0 ? Math.min(360, rest / 2) : 0;      // 2 minuten per graad
    klokken.forEach(k => {
      k.style.setProperty('--uur', `${uur}deg`);
      k.style.setProperty('--min', `${min}deg`);
      k.style.setProperty('--van', `${uur}deg`);
      k.style.setProperty('--span', `${vak}deg`);
      k.classList.toggle('dicht', vak === 0);
    });
  }

  klok();
  setInterval(() => { if (!document.hidden) klok(); }, 30000);
})();
